import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentFilters, LoanDocumentService, MessageService, QueryParamsService, CommonActionKey, SimpleDialogComponent, SimpleDialogService } from 'common';
import { routerTransition } from '../../shared/animations/router.animations';
import { UserPermissionService } from '../../user/user-permission/user-permission.service';
import { DocumentsFilterService } from './document-filter.service';
import { DocumentListComponent, AccountDocumentListComponentData } from './document-list-base.component';
import { getClearCacheSuccessDialogData, getConfirmDialogData, getNoDocsResultDialogData } from './account-document-list.data';

@UntilDestroy()
@Component({
    selector: 'ifb-account-documents',
    templateUrl: './account-document-list.component.html',
    styleUrls: ['./document-list.component.scss'],
    animations: routerTransition,
    standalone: false
})

export class AccountDocumentListComponent extends DocumentListComponent<LoanDocumentService> implements OnInit {

  override data: AccountDocumentListComponentData = undefined;

  constructor(
    route: ActivatedRoute,
    router: Router,
    userPermissionService: UserPermissionService,
    documentService: LoanDocumentService,
    accountDocumentsFilterService: DocumentsFilterService,
    messageService: MessageService,
    dialog: MatDialog,
    queryParamsService: QueryParamsService,
    simpleDialogService: SimpleDialogService) {
      super(route, router, documentService, accountDocumentsFilterService, messageService, dialog, userPermissionService, queryParamsService, simpleDialogService);
  }

  override ngOnInit(): void {
    this.route.data.pipe(untilDestroyed(this))
      .subscribe((it: AccountDocumentListComponentData) => {
        this.data = it;
        this.dataSource.data = this.data && this.data.documentQueryResult ? this.data.documentQueryResult.values : [];
      });

    this.onInitBase('servicing-account-documents');
  }

  override filter(): void {
    this.documentsFilterService.filter(new DocumentFilters(this.queryParams), this.paginator, this.sort);
  }

  clearCache(): void {
    SimpleDialogComponent.show(this.dialog, getConfirmDialogData(this.data.account?.loanNumber)).subscribe((actionKey: string) => {
      if(actionKey === CommonActionKey.Confirm) {
        const clearCacheSub = this.documentService.clearCache(this.data.account?.id).subscribe({
          next: (result: number) => {
            clearCacheSub.unsubscribe();
            if (result === 0) {
              SimpleDialogComponent.show(this.dialog, getNoDocsResultDialogData(this.data.account?.loanNumber))
            } else {
              SimpleDialogComponent.show(this.dialog, getClearCacheSuccessDialogData(this.data.account?.loanNumber, result))
            }
          },
          error: (error: any) => {
            clearCacheSub.unsubscribe();
            this.messageService.error(error);
          }
        });
      }
    });
  }
}
